import * as React from "react";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import ColorMaterialPicker from "@/src/components/ColorMaterialPicker.tsx";
import { useColorSwatches } from "@/src/hooks/useColorSwatches.ts";
import { SavingIndicator } from "@/src/components/SavingIndicator.tsx";

const SwatchSettings: React.FC = () => {
  const { t } = useTranslation();
  const { savedColorSwatches, setSavedColorSwatches, isSaving } =
    useColorSwatches();

  return (
    <div className="space-y-8">
      <SavingIndicator isSaving={isSaving} />

      <section className="space-y-4">
        {/* No section description here on purpose: the card below already
            titles both ways of creating a swatch. */}
        <h2 className="text-lg font-semibold text-gray-900">
          {t("settings.swatchCreateTitle")}
        </h2>

        {/* No card wrapper here: the picker renders the two options as cards
            of their own, and nesting them would blur that they are peers. */}
        <ColorMaterialPicker
          swatches={savedColorSwatches}
          onSwatchesChange={setSavedColorSwatches}
          renderSection="add"
        />
      </section>

      <section className="space-y-4">
        <h2 className="text-lg font-semibold text-gray-900">
          {t("settings.swatchLibraryTitle")}
        </h2>
        <p className="text-sm text-gray-500">
          {t("settings.swatchLibraryDescription")}
        </p>

        <div className="overflow-hidden rounded-xl border border-gray-100 bg-white p-6 shadow-sm">
          <ColorMaterialPicker
            swatches={savedColorSwatches}
            onSwatchesChange={setSavedColorSwatches}
            showMaterialDropdown
            allowRenaming
            allowUsageReferenceUpload
            renderSection="list"
          />
        </div>
      </section>
    </div>
  );
};

export const Route = createFileRoute("/settings/swatches")({
  component: SwatchSettings,
});
